import React,{useState, useEffect}  from 'react'
import './Template.css'
import Select from "react-select";
import { useDispatch } from 'react-redux';
import files from "./../../../../assets/templates/audit_template/Template.xlsx"
import ImportFileform from '../../../reUsableTemplates/ImportFileform/ImportFileform'
import mainicon from "../../../../assets/register_assets/inputMatix/CTC_Master/mainicon.png"
import EditableTable from '../../../reUsableTemplates/EditableTable/EditableTable'
import intomarkIcon from "../../../../assets/audit_assets/Audit_vendor/intomarkIcon.png"
import {createTemplate, uploadTemplateFile,multiDeleteTemplateFile,getTemplate,updateTemplateById,deleteTemplateById } from '../../../../services/global_redux/globale_actions/ActRuleActivity.action'
import { getActivity } from '../../../../services/global_redux/globale_actions/ActRuleActivity.action'
function Template({ setLoading, showSnackbar }) {
  const [file, setFile] = useState([])
  const [getData, setGetData] = useState([])
  const [editableRow, setEditableRow] = useState(null);
  const [editedValues, setEditedValues] = useState({})
  const dispatch = useDispatch();  
  const [createSingleTemplate,setCreateSingleTemplate] = useState(false);
  const [createOrUpdateform, setCreateOrUpdateform] = useState("Create");
  const [activitiesData, setActivitiesData] = useState([]);
  const addSingleData ={
    templateId: "",
    templateName:"",
    activities: []
  }
  const [form, setForm] = useState(addSingleData);
  const header = [
      { key: "templateId", value: "Template ID" , readOnly:true , icon: null },
      { key: "templateName", value: "Template Name" , readOnly:true , icon: null },
      { key: "activities", value: "Activities" ,readOnly:true , icon: null},
  ];
  
  const [actionChecked, setActionChecked] = useState("");
  
  const fetchActivity = async () =>{
    try{
      const response = await dispatch(getActivity());
      if(response.success){
        setActivitiesData(response.data);
      }else{
        setActivitiesData([]);
      }
    }catch(err){
      console.error("something went wrong",err);
    }
  }
  const fetchdata = async () => {
      try {
          const response = await dispatch(getTemplate());
          if (response.data) {
              setGetData(response.data);
          } 
      } catch (err) {
          console.error("Failed to fetch clients:", err);
      }
  }
  useEffect(() => {
      fetchActivity();
      fetchdata();
  }, [dispatch]);
  const handledeleteClickOpenalert = async (id) => {
      setLoading(true);
      try {
          const response = await dispatch(deleteTemplateById(id));
          if (response.success == true) {
              showSnackbar(response.message, 'success');
              setLoading(false);
              setEditableRow(null);
              fetchdata();
              setActionChecked("delete");
          } else {
              showSnackbar(response.message, 'warning');
              setLoading(false);
          }
      } catch (error) {
          showSnackbar('An error occurred', 'error');
          setLoading(false);
      }
  };

  // const handleFileUpload = async () => {
  //     if (file) {
  //         setLoading(true);
  //         console.log("dddsass",file);
  //         try {
  //             const response = await dispatch(uploadTemplateFile(file));
  //             console.log("upload employee master response", response);
  //             if (response.success == true) {
  //                 showSnackbar(response.message.message, 'success');
  //                 setLoading(false);
  //                 fetchdata();
  //                 setFile(null);
  //             } else {
  //                 showSnackbar(response.message, 'warning');
  //                 setLoading(false);
  //             }
  //         } catch (error) {
  //             showSnackbar('An error occurred', 'error');
  //             setLoading(false);
  //         }
  //     }
  // };


    const downloadBase64Excel = (contentBase64, filename) => {
        try {
            // Decode base64 to binary
            const byteCharacters = atob(contentBase64);
            const byteNumbers = new Array(byteCharacters.length);
            
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { 
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
            });
            
            // Create download link
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename || 'template_failed_rows.xlsx';
            document.body.appendChild(a); // Required for Firefox
            a.click();
            
            // Cleanup
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
            
            console.log('Error file downloaded successfully:', filename);
        } catch (e) {
            console.error('Download failed:', e);
            showSnackbar('Failed to download error file. Please try again.', 'error');
        }
    };

    const handleFileUpload = async () => {
        if (!file) {
            showSnackbar('Please select a file to upload', 'warning');
            return;
        }
        
        setLoading(true);
        
        try {
            const response = await dispatch(uploadTemplateFile(file));
            console.log("Upload temaplate response:", response);
            
            // ============================================================
            // HANDLE SUCCESS RESPONSE (status 200)
            // ============================================================
            if (response.success === true) {
                const data = response.data; // This is the backend response object
                
                setActionChecked("create");
                // Check if we have the expected response structure
                if (!data) {
                    showSnackbar('Unexpected response format', 'error');
                    setLoading(false);
                    return;
                }
                
                // Extract counts
                const insertedCount = data.inserted_count || 0;
                const failedCount = data.failed_count || 0;
                const totalRows = insertedCount + failedCount;
                
                // CASE 1: Full success (all rows inserted)
                if (insertedCount > 0 && failedCount === 0) {
                    showSnackbar(
                        data.message || `Successfully uploaded ${insertedCount} record(s)`, 
                        'success'
                    );
                    
                    // Refresh the data table
                    fetchdata();
                    setFile(null);
                }
                
                // CASE 2: Partial success (some rows inserted, some failed)
                else if (insertedCount > 0 && failedCount > 0) {
                    showSnackbar(
                        `Partial upload: ${insertedCount} of ${totalRows} record(s) added successfully. ` +
                        `${failedCount} record(s) failed. Downloading error file...`,
                        'warning',
                        6000 // Show for 6 seconds
                    );
                    
                    // Download error file
                    if (data.error_file && data.error_file.content_base64) {
                        downloadBase64Excel(
                            data.error_file.content_base64, 
                            data.error_file.filename
                        );
                    } else {
                        console.warn('No error file in response despite failed rows');
                    }
                    
                    // Refresh the data table (to show successfully inserted rows)
                    fetchdata();
                    // Don't clear the file - user might want to fix and re-upload
                }
                
                // CASE 3: Complete failure (all rows failed)
                else if (insertedCount === 0 && failedCount > 0) {
                    showSnackbar(
                        `Upload failed: All ${failedCount} record(s) have validation errors. ` +
                        `Downloading error file with details...`,
                        'error',
                        6000
                    );
                    
                    // Download error file
                    if (data.error_file && data.error_file.content_base64) {
                        downloadBase64Excel(
                            data.error_file.content_base64, 
                            data.error_file.filename
                        );
                    } else {
                        console.warn('No error file in response despite all rows failing');
                        // Fallback: show the message if available
                        if (data.message) {
                            showSnackbar(data.message, 'error', 8000);
                        }
                    }
                }
                
                // CASE 4: Unexpected state (shouldn't happen but handle gracefully)
                else {
                    showSnackbar(
                        data.message || 'Upload completed with unexpected result', 
                        'info'
                    );
                }
                
                setLoading(false);
            }
            
            // ============================================================
            // HANDLE ERROR RESPONSE (non-200 status)
            // ============================================================
            else {
                const errorMsg = response.error || 'Upload failed';
                
                // Handle different error types
                if (typeof errorMsg === 'string') {
                    showSnackbar(errorMsg, 'error');
                } else if (Array.isArray(errorMsg)) {
                    // If backend returns array of errors
                    const displayError = errorMsg.slice(0, 3).join('; ') + 
                        (errorMsg.length > 3 ? ` ... and ${errorMsg.length - 3} more errors` : '');
                    showSnackbar(displayError, 'error');
                } else if (typeof errorMsg === 'object' && errorMsg.error) {
                    showSnackbar(errorMsg.error, 'error');
                } else {
                    showSnackbar('An error occurred during upload', 'error');
                }
                
                setLoading(false);
            }
            
        } catch (error) {
            // This catches any unexpected errors in the frontend code
            console.error('Upload error:', error);
            showSnackbar('An unexpected error occurred. Please try again.', 'error');
            setLoading(false);
        }
    };



  const submitdelete = async (id) => {
      setLoading(true);
      try {
          const response = await dispatch(multiDeleteTemplateFile(id));
          if (response.success == true) {
              showSnackbar(response.message.message, 'success');
              setLoading(false);
              fetchdata();
              setActionChecked("delete");
          } else {
              showSnackbar(response.message, 'warning');
              setLoading(false);
          }
      } catch (error) {
          showSnackbar('An error occurred', 'error');
          setLoading(false);
      }

  }
  
  const handleSaveClick = async (e) => {
      // setLoading(true);
      // try {
      //     const response = await dispatch(updateTemplateById(editedValues.id, editedValues));
      //     if (response.success == true) {
      //         showSnackbar(response.message, 'success');
      //         setLoading(false);
      //         setEditableRow(null);
      //         fetchdata();
      //     } else {
      //         showSnackbar(response.message, 'warning');
      //         setLoading(false);
      //     }
      // } catch (error) {
      //     showSnackbar('An error occurred', 'error');
      //     setLoading(false);
      // }
  };
  const opencreateSingle = () =>{
    setCreateSingleTemplate(true)
    setForm(addSingleData);
    setCreateOrUpdateform('Create');
  }
  const editableTable = (data) =>{
    const item = getData.find(d => d.id === data);
    setCreateSingleTemplate(true)
    setCreateOrUpdateform('Update');
    setForm({
      templateId: item.templateId,
      templateName: item.templateName,
      activities: item.activities,
      id:data
     })

  }
  const UpdateClinetMappingSubmit = async(e) => {
    e.preventDefault();
    setLoading(true);
    try{
      const response = await dispatch(updateTemplateById(form.id,form));
      if(response.success){
        setForm(addSingleData);
        setCreateSingleTemplate(false)
        setLoading(false);
        showSnackbar(response.message,'success');
        fetchdata();
      }else{
        setLoading(false);
        showSnackbar(response.message,'warning');
      }
    }catch(err){
      setLoading(false);
      console.error("something went wrong",err)
    }
  };
  const activityOptions = activitiesData.map((item) => ({
    value: item.activityId,
    label: item.activityId,
  }));
  const CreateTemplateSubmit = async (e)=>{
    e.preventDefault();
    setLoading(true);
    try{
      const response = await dispatch(createTemplate(form));
      if(response.success){
        fetchdata();
        setForm(addSingleData);
        setCreateSingleTemplate(false)
        setLoading(false);
        showSnackbar(response.message.message,'success');
        setActionChecked("create");
      }else{
        setLoading(false);
        showSnackbar(response.error,'warning');
      }
    }catch(err){
      setLoading(false);
      console.error("something went wrong",err)
    }
  }
  return (
    <div className='container-fluid'>
        <ImportFileform
            setFiledata={setFile}
            title={'Template'}
            filestemp={files}
            handleFileUpload={handleFileUpload}
            File={file}
        />
        <EditableTable
        
        header={header}
        mainIcon={mainicon}
        title={'Template'}
        data={getData}
        setEditableRow={setEditableRow}
        setEditedValues={setEditedValues}
        handledeleteClickOpenalert={handledeleteClickOpenalert}
        editableRow={editableRow}
        setLoading={setLoading}
        editedValues={editedValues}
        getEditPermission = {true}
        getDeletePermission = {true}
        // date={date}
        submitdelete={submitdelete}
        handleSaveClick={handleSaveClick}
        showSnackbar={showSnackbar}
        mainIconColor={"#4ad991"}
        editableTable={editableTable}
        actionChecked={actionChecked}
        setActionChecked={setActionChecked}
        createOrfilterComp={
            <>
            <button onClick={opencreateSingle}>Create Template</button>
            </>
        }
        />
        {createSingleTemplate && (
          <>
            <div className="createTemplateMappingContainerd">
            {createOrUpdateform === "Create" ?<>
            <div className="createTemplateMappingContainerd-module shadow">
              <div className="create-TemplateMapping-header d-flex justify-content-between">
                <div className="div">
                  <h5>Template Creation</h5>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                    sed do eiusmod tempor incididunt ut labore aliqua
                  </p>
                </div>
                <button
                  className="into-btn-icon"
                  onClick={() => setCreateSingleTemplate(false)}
                >
                <img src={intomarkIcon} alt="" />
                </button>
              </div>

              <div className="">
                <div className="container mt-2">
                  <div className="form-container">
                    <form 
                    onSubmit={CreateTemplateSubmit}
                    >
                      
                        <>
                        
                        <div className="row templateMapping-form">
                          <div className="col-md-12">
                            <label>Template ID</label>
                            <input type="text" 
                          className="form-control"
                          value={form.templateId}
                          onChange={(e) =>
                            setForm({ ...form, templateId: e.target.value })
                          }
                          required
                          />
                          </div>

                          <div className="col-md-12">
                            <label>Template Name</label>
                            <input type="text" 
                          className="form-control"
                          value={form.templateName}
                          onChange={(e) =>
                            setForm({ ...form, templateName: e.target.value })
                          }
                          required/>
                          </div>

                          <div className="col-md-12">
                            <label>Activity ID</label>
                            <Select
                              isMulti
                              required
                              options={activityOptions}
                              value={form.activities?.map((id) => ({
                                value: id,
                                label:
                                  activityOptions.find((opt) => opt.value === id)?.label || id,
                              }))}
                              onChange={(selectedOptions) =>
                                setForm({
                                  ...form,
                                  activities: selectedOptions.map((opt) => opt.value),
                                })
                              }
                              placeholder="Select activities..."
                              classNamePrefix="react-select"
                            />
                          </div>
                        </div>


                          <div className="text-end mt-3">
                            <button
                              type="submit"
                              className="btn btn-primary px-4"
                            >
                              submit
                            </button>
                          </div>
                        </>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            </>:<>

            <div className="createTemplateMappingContainerd-module shadow">
              <div className="create-TemplateMapping-header d-flex justify-content-between">
                <div className="div">
                  <h5>Update Template to the client</h5>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                    sed do eiusmod tempor incididunt ut labore aliqua
                  </p>
                </div>
                <button
                  className="into-btn-icon"
                  onClick={() => setCreateSingleTemplate(false)}
                >
                <img src={intomarkIcon} alt="" />
                </button>
              </div>

              <div className="">
                <div className="container mt-2">
                  <div className="form-container">
                    <form 
                    onSubmit={UpdateClinetMappingSubmit}
                    >
                      
                        <>
                          <div className="row templateMapping-form">
                            <div className="col-md-12">
                              <label>Template ID</label>
                              <input type="text" 
                            className="form-control"
                            value={form.templateId}
                            onChange={(e) =>
                              setForm({ ...form, templateId: e.target.value })
                            }
                            readOnly
                            required
                            />
                            </div>

                            <div className="col-md-12">
                              <label>Template Name</label>
                              <input type="text" 
                            className="form-control"
                            value={form.templateName}
                            onChange={(e) =>
                              setForm({ ...form, templateName: e.target.value })
                            }
                            
                            required/>
                            </div>

                            <div className="col-md-12">
                              <label>Activity ID</label>
                              <Select
                                isMulti
                                required
                                options={activityOptions}
                                value={form.activities?.map((id) => ({
                                  value: id,
                                  label:
                                    activityOptions.find((opt) => opt.value === id)?.label || id,
                                }))}
                                onChange={(selectedOptions) =>
                                  setForm({
                                    ...form,
                                    activities: selectedOptions.map((opt) => opt.value),
                                  })
                                }
                                placeholder="Select activities..."
                                classNamePrefix="react-select"
                              />
                            </div>
                          </div>


                          <div className="text-end mt-3 d-flex justify-content-between">
                            <button
                              type="button"
                              className="btn btn-primary px-4"
                              onClick={() => setCreateSingleTemplate(false)}
                            >
                              Cancel
                            </button>
                            <button
                              type="submit"
                              className="btn btn-success px-4"
                            >
                              Update
                            </button>
                          </div>
                        </>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            </>}
            </div>
          </>
        )}
    </div>
  )
}

export default Template